export const iconFontAwesomeArrowsSquareUpRight = (
	<i className="fa-solid fa-square-up-right"></i>
);
